import { render } from "./NoteCreate.vue?vue&type=template&id=671c7e8e"
import script from "./NoteCreate.vue?vue&type=script&lang=js"
export * from "./NoteCreate.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__